import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import { Radio } from 'antd';
import { rowSizes } from '../../../../../../utils/rowSizing';
import styles from '../../config.less';

class RowHeight extends React.PureComponent {
  availableItems = Object.keys(rowSizes);

  onChange = (e) => {
    this.props.onChange(e.target.value);
  };

  render() {
    const { value } = this.props;

    return (
      <Radio.Group
        style={{ width: '100%', display: 'flex', textAlign: 'center' }}
        onChange={this.onChange}
        value={value}
      >
        <Radio.Button className={styles.rowHeightButton} key="sm" value="sm">
          <div className={styles.rowHeightButtonIcon}>
            <svg width="14" height="14" viewBox="0 0 11 11" fill="none">
              <path
                d="M0 0.5H11 M0 2.5H11 M0 4.5H11 M0 6.5H11 M0 8.5H11 M0 10.5H11"
                stroke="#666b70"
                stroke-width="1"
              />
            </svg>
          </div>
        </Radio.Button>
        <Radio.Button className={styles.rowHeightButton} key="md" value="md">
          <div className={styles.rowHeightButtonIcon}>
            <svg width="14" height="14" viewBox="0 0 11 11" fill="none">
              <path d="M0 1H11 M0 4H11 M0 7H11 M0 10H11" stroke="#666b70" stroke-width="2" />
            </svg>
          </div>
        </Radio.Button>
        <Radio.Button className={styles.rowHeightButton} key="lg" value="lg">
          <div className={styles.rowHeightButtonIcon}>
            <svg width="14" height="14" viewBox="0 0 11 11" fill="none">
              <path d="M0 1.5H11 M0 5.5H11 M0 9.5H11" stroke="#666b70" stroke-width="3" />
            </svg>
          </div>
        </Radio.Button>
        <Radio.Button className={styles.rowHeightButton} key="xl" value="xl">
          <div className={styles.rowHeightButtonIcon}>
            <svg width="14" height="14" viewBox="0 0 11 11" fill="none">
              <path d="M0 2.5H11 M0 8.5H11" stroke="#666b70" stroke-width="5" />
            </svg>
          </div>
        </Radio.Button>
      </Radio.Group>
    );
  }
}

RowHeight.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number,
};

export default withTranslation()(RowHeight);
